/*
 * Copyright ©2020. Open Digital Solutions, Novi Sad. Sva prava zadržana.
 * Pravo da se koristi, kopira, modifikuje i distribuira ovaj softver i njegova dokumentacija
 * u bilo koje svrhe, bez naknade ili bez potpisanog sporazuma sa vlasnikom softvera, nije dozvoljeno.
 */

import { Paper } from './paper.model';

export class Delivery {
   ouId: string;
   csrId: number;
   csrName: string;
   comment: string | null;
   papers: Paper[];
}
